// extracted by mini-css-extract-plugin
module.exports = {"msgLimit":"CreateSMS_msgLimit__2dU3r","patientName":"CreateSMS_patientName__37lVJ"};